<template>
	<v-container>
		<v-card class="shadowCard">
      <v-subheader>Resultados EXCI</v-subheader>
      <v-card-text v-if="verExci">
        <div v-if="mensajeExci">
          <div class="mb-4">
            <v-chip small color="primary" text-color="white" class="mr-2 mb-2">
              Diagnóstico: {{ califDiagnostico }}
            </v-chip>
            <v-chip small color="primary" text-color="white" class="mb-2">
              Final: {{ califFinal }}
            </v-chip>
          </div>

          <div class="resultado-exci">
            {{ mensajeExci }}
          </div>
        </div>

        <div v-else class="row justify-content-md-center">
  				<iframe :src="url" width="100%" height="500px"></iframe>
        </div>
      </v-card-text>
    </v-card>
    
    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>
  </v-container>
</template>
<script>
	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
	import Avataaars  from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const  base64 = require('base-64');


  export default {
  	props:[
			'perfil'
	  ],

  	components:{
  		Alerta,
  		Avataaars,
  	},

    data: () => ({
    	respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	url:'',
      mensajeExci: '',
      califDiagnostico: 0,
      califFinal: 0,

     	verExci: false
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),
    },

    created () {
    	const id_usuario = base64.encode( this.getUsuarioLMS.id )
      // Hacemos la petición
      this.$http.get('calificacion.exci/' + id_usuario).then( response => {
        const resultadoExci = response.body.exci || {}
        this.url = response.body.RUTA_EXCI
        this.mensajeExci = resultadoExci.mensaje || ''
        this.califDiagnostico = resultadoExci.calif1 || 0
        this.califFinal = resultadoExci.calif2 || 0
        this.verExci = true
      }).catch( error =>{
        if( error.status == 400 || error.status == 500){
    			this.parametros.mensaje      = error.body.message
    			this.parametros.dialogError  = true 
    			this.parametros.color        = '#FF2C2C' 
    			this.respuestaAlerta         = true 
    		}
      }).finally(()=>{ this.cargar = false })
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario', 'grabarAvatar' ]),
    },
  }
</script>

<style scoped>
.resultado-exci {
  white-space: pre-line;
  line-height: 1.6;
  font-size: 15px;
}
</style>